import { render, staticRenderFns } from "./adsErrorList.vue?vue&type=template&id=3066b0ad&scoped=true"
import script from "./adsErrorList.vue?vue&type=script&lang=js"
export * from "./adsErrorList.vue?vue&type=script&lang=js"
import style0 from "./adsErrorList.vue?vue&type=style&index=0&id=3066b0ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3066b0ad",
  null
  
)

export default component.exports